import { Component, OnInit, Inject } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Selecao } from 'src/app/models/selecao';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Fileira } from 'src/app/models/fileira';
import { SelecaoModalComponent } from 'src/app/modals/selecao-modal/selecao-modal.component';
import { opcoesOrientacao, opcoesTelhado } from 'src/app/globals';
import { DetalheEstruturaModalComponent } from 'src/app/modals/detalhe-estrutura-modal/detalhe-estrutura-modal.component';
import { PedidoService } from 'src/app/services/pedido.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import swal from 'sweetalert2';
import { PremissasService } from 'src/app/services/premissas.service';
import { GlobalService } from 'src/app/services/global.service';
import { FornecedorEstruturaService } from 'src/app/services/fornecedor-estrutura.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-estrutura',
  templateUrl: './cadastrar-estrutura.component.html',
  styleUrls: ['./cadastrar-estrutura.component.scss']
})
export class CadastrarEstruturaComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};


  fileira: Fileira;
  fornecedoresDisponiveis: any[] = [];
  fornecedoresUtilizados: number[] = [];
  possuiLargura = false;
  quantidadeDePaineis: number;
  totalPaineis: number;
  calculadora: boolean;
  mostrarTelhado = false;
  orientacaoPaisagem = true;
  mostrarValores = false;
  integrador = false;
  usarTelCeramico = true;
  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();
  novaQuantidadePaineis;
  possuiComprimento = false;
  qtdMaxPainelPorFileira = 0;

  constructor(public dialogRef: MatDialogRef<CadastrarEstruturaComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog, private pedidoService: PedidoService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private premissasService: PremissasService, private globalService: GlobalService, private fornecedorEstruturaService: FornecedorEstruturaService, private utilitarioService: UtilitarioService) {

  }

  async ngOnInit() {
    this.fileira = this.data.fileira;
    this.possuiLargura = this.fileira.larguraPainel !== null && this.fileira.larguraPainel !== undefined;
    this.possuiComprimento = this.fileira.comprimentoPainel !== null && this.fileira.comprimentoPainel !== undefined;
    this.fornecedoresUtilizados = this.data.fornecedoresUtilizados;
    this.quantidadeDePaineis = this.data.quantidadeDePaineis;
    this.totalPaineis = this.data.totalPaineis;
    this.calculadora = this.data.calculadora;
    this.novaQuantidadePaineis = this.data.novaQuantidadePaineis;
    this.integrador = await this.globalService.integrador();
    this.buscarVerPrecosProdutos();
    this.buscarDesativarPaisagem();
    this.buscarUsarTelhadoCeramico();
    this.buscarEstruturasPersonalizadas();
    this.buscarQtdPainelPorFileira();

    if(this.novaQuantidadePaineis !== undefined) {
      this.fileira.numPaineis += this.novaQuantidadePaineis;

      this.salvar();
    }
  }

  buscarQtdPainelPorFileira() {
    this.carregandoService.mostra('buscarQtdPainelPorFileira');
    this.premissasService.consultarQtdPainelPorFileira().subscribe(
      (f) => {
        this.qtdMaxPainelPorFileira = f.valor;
        this.carregandoService.esconde('buscarQtdPainelPorFileira');
      },
      (erro) => {
        this.carregandoService.esconde('buscarQtdPainelPorFileira');
        this.notificacaoService.erro(erro);
      }
    );
  }

  selecionarEstrutura(tipo) {
    const dialogRef = this.dialog.open(SelecaoModalComponent, {
      width: ($('body').width()).toString() + 'px',
      // passa os produtos já selecionados
      data: {
        titulo: tipo === 0 ? 'Selecione uma Orientação' : 'Selecione um Tipo de Telhado', opcoes: tipo === 0 ? opcoesOrientacao : opcoesTelhado
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: Selecao) => {
      if (result) {
        if (tipo === 0) {
          this.fileira.orientacao = result.id;
          this.fileira.opcaoOrientacao = result;
        } else {
          this.fileira.telhado = result.id;
          this.fileira.opcaoTelhado = result;
        }
      }
    });
  }

  salvar() {
    // if (this.calculadora && this.quantidadeDePaineis < this.totalPaineis + this.fileira.fileiras * this.fileira.numPaineis) {
    //   swal({
    //     title: 'Atenção!!',
    //     text: 'Não é possível adicionar mais paineis que a quantidade indicada pela calculadora: ' + this.quantidadeDePaineis + ' painéis.',
    //     type: 'warning',
    //     showCancelButton: false,
    //     confirmButtonClass: 'btn btn-info',
    //     confirmButtonText: 'OK',
    //     buttonsStyling: false
    //   }).then((result) => {

    //   });
    // }
    // else {
    //   this.dialogRef.close(this.fileira);
    // }

    if (!this.validar()) {
      return;
    }

    this.dialogRef.close(this.fileira);
  }

  fechar() {
    this.dialogRef.close();
  }

  validar() {
    return this.fileira.fileiras && this.fileira.numPaineis && this.fileira.orientacao !== undefined && this.fileira.telhado !== undefined && (this.fileira.fornecedor !== null || this.fileira.idFornecedorEstrutura !== null) && (this.fileira.fornecedor !== undefined || this.fileira.idFornecedorEstrutura !== undefined) && this.fornecedoresDisponiveis !== null && this.fornecedoresDisponiveis !== undefined && this.fornecedoresDisponiveis.length > 0;
  }

  detalhesDaEstrutura(itens) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheEstruturaModalComponent, {
      width: largura > 1100 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {
        itens: itens
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  selecionarTelhado(telhado) {
    this.fileira.telhado = telhado;
    // if (telhado === 6) {
    //   this.fileira.orientacao = 'retrato';
    // }
    this.buscarFornecedores();
  }

  buscarFornecedores() {
    if (this.fileira.fileiras !== undefined) {
      this.fileira.fileiras = Number(this.fileira.fileiras);
    }
    if (this.fileira.numPaineis !== undefined) {
      this.fileira.numPaineis = Number(this.fileira.numPaineis);
    }
    if (this.fileira.orientacao === undefined || this.fileira.telhado === undefined) {
      return;
    }
    this.carregandoService.mostra('buscarFornecedores');
    this.pedidoService.buscarFornecedoresEstrutura(this.fileira).subscribe(resp => {
      this.fornecedoresDisponiveis = resp;
      // if (this.fornecedoresUtilizados.length > 0 && this.fornecedoresUtilizados.some(p => p !== null && p !== undefined)) {
      //   this.fornecedoresDisponiveis = this.fornecedoresDisponiveis.filter(p => this.fornecedoresUtilizados.some(u => u === p.fornecedor));
      // }
      if (!this.fornecedoresDisponiveis.some(f => f.fornecedor === this.fileira.fornecedor)) {
        this.fileira.fornecedor = undefined;
      }

      this.fornecedoresDisponiveis.forEach((forn: any) => {
        if(forn.idFornecedorEstrutura !== null && forn.idFornecedorEstrutura !== undefined) {
          forn.logo$ = this.fornecedorEstruturaService.consultarImagemPorId(forn.idFornecedorEstrutura)
            .map(m => m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('')).toPromise();
          forn.logo$.then(p => { forn.buscouImagem = true; });
        }
      });

      this.carregandoService.esconde('buscarFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('buscarFornecedores');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarOrientacao(orientacao) {
    this.fileira.orientacao = orientacao;
    this.buscarFornecedores();
  }

  validaNumPaineis() {
    if (this.fileira.numPaineis !== null && this.fileira.numPaineis !== undefined && this.qtdMaxPainelPorFileira > 0 && this.fileira.numPaineis > this.qtdMaxPainelPorFileira) {
      swal({
        title: 'Atenção!!',
        text: 'A estrutura selecionada só permite ' + this.qtdMaxPainelPorFileira + ' painéis por fileira!',
        type: 'warning',
        confirmButtonClass: 'btn btn-warning',
        buttonsStyling: false,
        allowEnterKey: false
      }).then((result) => {

        this.fileira.numPaineis = this.qtdMaxPainelPorFileira;
        this.buscarFornecedores();

      });
    }
  }

  // validaNumPaineis() {
  //   if (this.fileira.numPaineis !== null && this.fileira.numPaineis !== undefined && this.fileira.fornecedor !== undefined
  //     && this.fileira.fornecedor !== null && this.fileira.fornecedor === 2 && this.fileira.numPaineis > 20) {
  //     swal({
  //       title: 'Atenção!!',
  //       text: 'A estrutura selecionada só permite 20 painéis por fileira! Deseja selecioná-la mesmo assim?',
  //       type: 'warning',
  //       showCancelButton: true,
  //       confirmButtonClass: 'btn btn-info',
  //       cancelButtonClass: 'btn btn-danger',
  //       confirmButtonText: 'Sim',
  //       cancelButtonText: 'Não',
  //       buttonsStyling: false
  //     }).then((result) => {
  //       if (result.value) {
  //         this.fileira.numPaineis = 20;
  //         this.buscarFornecedores();
  //       }
  //       else {
  //         this.fileira.fornecedor = undefined;
  //       }
  //     });
  //   }
  // }

  selecionarFornecedor(fornecedor) {
    if(fornecedor.idFornecedorEstrutura) {
      this.fileira.idFornecedorEstrutura = fornecedor.idFornecedorEstrutura;
    } else {
      this.fileira.fornecedor = fornecedor.fornecedor;
    }

    if (this.fileira.numPaineis !== null && this.fileira.numPaineis !== undefined && this.fileira.numPaineis > 20 && fornecedor === 2) {
      swal({
        title: 'Atenção!!',
        text: 'A estrutura selecionada só permite 20 painéis por fileira! Deseja selecioná-la mesmo assim?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.fileira.numPaineis = 20;
          this.buscarFornecedores();
        }
        else {
          this.fileira.fornecedor = undefined;
        }
      });


    }
  }

  verificarMostrarTelhado() {
    this.carregandoService.mostra('verificarMostrarTelhado');
    this.premissasService.consultarTelhadaNaCalculadora().subscribe(dados => {
      this.mostrarTelhado = dados.valor;
      if (this.mostrarTelhado) {
        this.fileira.orientacao = 'retrato';
      }
      this.carregandoService.esconde('verificarMostrarTelhado');
    }, (erro) => {
      this.carregandoService.esconde('verificarMostrarTelhado');
      this.notificacaoService.erro(erro);
    });
  }

  buscarDesativarPaisagem() {
    this.carregandoService.mostra('buscarDesativarPaisagem');
    this.premissasService.consultarDesativarPaisagem().subscribe(f => {
      this.orientacaoPaisagem = f.valor;
      if (!this.orientacaoPaisagem) {
        this.fileira.orientacao = 'retrato';
      }
      this.carregandoService.esconde('buscarDesativarPaisagem');
    }, (erro) => {
      this.carregandoService.esconde('buscarDesativarPaisagem');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEstruturasPersonalizadas() {
    this.carregandoService.mostra('buscarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(f => {
      this.estruturasPersonalizadas = f;
      if (!this.orientacaoPaisagem) {
        this.fileira.orientacao = 'retrato';
      }
      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstruturasPersonalizadas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarUsarTelCeramico().subscribe(f => {
      this.usarTelCeramico = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }
}
